import { feedbackServices } from '@/services';

const {
  getFeedbackStats,
  getFeedbackList,
  getFeedbackUser,
  resolveFeedback,
  dismissFeedback,
} = feedbackServices;

const notifyError = (dispatch, error) => {
  const { message, statusText } = error || {};
  dispatch(
    'notifications/displayNotification',
    { message: message || statusText || 'Unable to complete request', type: 'danger' },
    { root: true }
  );
};

export default {
  namespaced: true,
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {
    async getFeedbackStats({ dispatch }, query = {}) {
      try {
        const response = await getFeedbackStats(query.from || '', query.to || '');
        return response.mapped;
      } catch (error) {
        notifyError(dispatch, error);
      }
    },
    async getFeedbackList({ dispatch }, query = {}) {
      try {
        const response = await getFeedbackList(query);
        return response.mapped;
      } catch (error) {
        notifyError(dispatch, error);
        return {
          data: [],
          pagination: { page: 1, pageSize: query.pageSize || 25, total: 0 },
        };
      }
    },
    async getFeedbackUser({ dispatch }, userId) {
      try {
        const response = await getFeedbackUser(userId);
        return response.mapped;
      } catch (error) {
        notifyError(dispatch, error);
      }
    },
    async resolveFeedback({ dispatch }, { id, comments }) {
      try {
        const response = await resolveFeedback(id, comments);
        if ([200, 201, 204].includes(response.status)) {
          dispatch(
            'notifications/displayNotification',
            { message: 'Feedback marked as resolved', type: 'success' },
            { root: true }
          );
        }
        return response;
      } catch (error) {
        notifyError(dispatch, error);
      }
    },
    async dismissFeedback({ dispatch }, { id, comments }) {
      try {
        const response = await dismissFeedback(id, comments);
        if ([200, 201, 204].includes(response.status)) {
          dispatch(
            'notifications/displayNotification',
            { message: 'Feedback dismissed', type: 'success' },
            { root: true }
          );
        }
        return response;
      } catch (error) {
        notifyError(dispatch, error);
      }
    },
  },
};
